const UnderscoreIcon = () => (
	<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M2.83398 11.5H16.834"
			stroke="#1A0638"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export default UnderscoreIcon;
